<app-permit-common-details [permit]="permit"></app-permit-common-details>

@if (permit.employer && (permit.employer.name || permit.employer.abn)) {
    <dl class="row mb-0 mt-2">
        <dt class="col-sm-4">Employer</dt>
        <dd class="col-sm-8">{{ permit.employer.name || '-' }}</dd>

        @if (permit.employer.abn) {
            <dt class="col-sm-4">ABN</dt>
            <dd class="col-sm-8">{{ permit.employer.abn }}</dd>
        }
        @if (permit.employer.phone) {
            <dt class="col-sm-4">Business phone</dt>
            <dd class="col-sm-8">{{ permit.employer.phone }}</dd>
        }
        @if (permit.employer.address) {
            <dt class="col-sm-4">Business address</dt>
            <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.employer.address }}</dd>
        }
        @if (permit.employer.website) {
            <dt class="col-sm-4">Website</dt>
            <dd class="col-sm-8"><a [href]="permit.employer.website" target="_blank" rel="noopener">{{ permit.employer.website }}</a></dd>
        }
    </dl>
}
